/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFUnauthorizedError
 */
export interface CRSFUnauthorizedError {
    /**
     * 
     * @type {string}
     * @memberof CRSFUnauthorizedError
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFUnauthorizedError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFUnauthorizedError
     */
    title: string;
}

/**
 * Check if a given object implements the CRSFUnauthorizedError interface.
 */
export function instanceOfCRSFUnauthorizedError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;

    return isInstance;
}

export function CRSFUnauthorizedErrorFromJSON(json: any): CRSFUnauthorizedError {
    return CRSFUnauthorizedErrorFromJSONTyped(json, false);
}

export function CRSFUnauthorizedErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFUnauthorizedError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
        'status': json['status'],
        'title': json['title'],
    };
}

export function CRSFUnauthorizedErrorToJSON(value?: CRSFUnauthorizedError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'status': value.status,
        'title': value.title,
    };
}

